<template>
  <div class="local-comment-component">
    <div class="comment-form">
      <el-input
        v-model="commentContent"
        type="textarea"
        :rows="4"
        placeholder="请输入评论内容..."
        maxlength="500"
        show-word-limit
      ></el-input>
      <div class="comment-actions">
        <EmojiPicker @select="insertEmoji" />
        <el-button type="primary" @click="submitComment" :loading="submitting" :disabled="!commentContent.trim()">提交评论</el-button>
      </div>
    </div>

    <div class="comments-list">
      <div class="comment-item" v-for="comment in commentList" :key="comment.id">
        <div class="comment-avatar" @click="goToUserCenter(comment.userId)">
          <el-avatar :size="40" :src="comment.userIcon || defaultAvatar" style="cursor: pointer;">
            <i class="el-icon-user"></i>
          </el-avatar>
        </div>
        <div class="comment-content">
          <div class="comment-header">
            <span class="comment-author" @click="goToUserCenter(comment.userId)" style="cursor: pointer;">{{ comment.userName }}</span>
            <span class="comment-time">{{ formatDate(comment.createTime) }}</span>
          </div>
          <div class="comment-text">{{ comment.content }}</div>
          <div class="comment-footer">
            <el-button type="text" size="small" @click="replyComment(comment)">
              <i class="el-icon-chat-line-round"></i> 回复
            </el-button>
            <el-button type="text" size="small" @click="likeComment(comment)">
              <i class="el-icon-thumb" :class="{ 'liked': comment.isLiked }"></i> 
              <span v-if="comment.likeCount > 0">{{ comment.likeCount }}</span>
            </el-button>
          </div>
          
          <!-- 回复表单 -->
          <div class="reply-form" v-if="currentReplyTarget.parentId === comment.id">
            <el-input
              v-model="replyContent"
              type="textarea"
              :rows="2"
              :placeholder="replyToUserName ? '回复 @' + replyToUserName + '...' : '请输入回复内容...'"
              maxlength="500"
              show-word-limit
            ></el-input>
            <div class="reply-actions">
              <div class="emoji-wrapper">
                <EmojiPicker @select="insertReplyEmoji" />
              </div>
              <div>
                <el-button type="primary" size="small" @click="submitReply(comment)" :loading="replySubmitting">回复</el-button>
                <el-button size="small" @click="cancelReply">取消</el-button>
              </div>
            </div>
          </div>
          
          <!-- 回复列表 -->
          <div class="reply-list" v-if="comment.replies && comment.replies.length > 0">
            <div class="reply-item" v-for="reply in comment.replies" :key="reply.id">
              <div class="reply-content">
                <span class="reply-author" @click="goToUserCenter(reply.userId)" style="cursor: pointer;">{{ reply.userName }}</span>
                <span v-if="reply.replyToUserName" class="reply-to"> 回复 <span class="reply-to-user">@{{ reply.replyToUserName }}</span></span>
                <span class="reply-text">: {{ reply.content }}</span>
              </div>
              <div class="reply-meta">
                <span class="reply-time">{{ formatDate(reply.createTime) }}</span>
                <el-button type="text" size="small" @click="replyComment(comment, reply)">
                  <i class="el-icon-chat-line-round"></i> 回复
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="no-comments" v-if="commentList.length === 0">
        暂无评论，快来抢沙发吧~
      </div>
    </div>
    
    <!-- 评论分页 -->
    <div class="comment-pagination" v-if="totalComments > 0">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next"
        :total="totalComments">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EmojiPicker from './EmojiPicker.vue'
export default {
  name: 'LocalComment',
  components: {
    EmojiPicker
  },
  props: {
    sourceId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      commentContent: '',
      commentList: [],
      submitting: false,
      replySubmitting: false,
      currentPage: 1,
      pageSize: 10,
      totalComments: 0,
      replyContent: '',
      replyToUserName: '',
      currentReplyTarget: {
        parentId: null,
        replyToId: null
      },
      defaultAvatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
    }
  },
  mounted() {
    this.loadComments()
  },
  methods: {
    async loadComments() {
      try {
        const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}')
        const response = await this.$axios({
          method: 'post',
          url: '/comment/list',
          data: {
            sourceId: this.sourceId,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            token: loginResult.token || '',
            userId: loginResult.userId || '',
            userName: loginResult.userName || '',
            ip: '',
            source: 'web'
          }
        })
        
        if (response.code === 200 || response.code === '200') {
          this.commentList = response.data || []
          this.totalComments = response.data.length
        } else {
          this.$message.error(response.msg || '获取评论失败')
        }
      } catch (error) {
        console.error('加载评论失败:', error)
        this.$message.error('获取评论失败')
      }
    },
    
    async submitComment() {
      if (!this.commentContent.trim()) {
        this.$message.warning('请输入评论内容')
        return
      }
      
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}')
      if (!loginResult.userId) {
        this.$message.warning('请先登录')
        this.$router.push({ name: 'Login', query: { redirect: this.$route.fullPath } })
        return
      }
      
      this.submitting = true
      
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/comment/add',
          data: {
            sourceType: 'doc',
            sourceId: this.sourceId,
            content: this.commentContent.trim(),
            token: loginResult.token || '',
            userId: loginResult.userId,
            userName: loginResult.userName || '',
            ip: '',
            source: 'web'
          }
        })
        
        if (response.code === 200 || response.code === '200') {
          this.$message.success('评论成功')
          this.commentContent = ''
          this.currentPage = 1
          this.loadComments()
          this.$emit('comment-added')
        } else {
          this.$message.error(response.msg || '评论失败')
        }
      } catch (error) {
        console.error('提交评论失败:', error)
        this.$message.error('评论失败')
      } finally {
        this.submitting = false
      }
    },
    
    async submitReply(parentComment) {
      if (!this.replyContent.trim()) {
        this.$message.warning('请输入回复内容')
        return
      }
      
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}')
      if (!loginResult.userId) {
        this.$message.warning('请先登录')
        return
      }
      
      this.replySubmitting = true
      
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/comment/add',
          data: {
            sourceType: 'doc',
            sourceId: this.sourceId,
            content: this.replyContent.trim(),
            parentId: parentComment.id,
            replyToId: this.currentReplyTarget.replyToId || null,
            token: loginResult.token || '',
            userId: loginResult.userId,
            userName: loginResult.userName || '',
            ip: '',
            source: 'web'
          }
        })
        
        if (response.code === 200 || response.code === '200') {
          this.$message.success('回复成功')
          this.replyContent = ''
          this.cancelReply()
          this.loadComments()
        } else {
          this.$message.error(response.msg || '回复失败')
        }
      } catch (error) {
        console.error('提交回复失败:', error)
        this.$message.error('回复失败')
      } finally {
        this.replySubmitting = false
      }
    },
    
    replyComment(comment, replyTo) {
      this.currentReplyTarget = {
        parentId: comment.id,
        replyToId: replyTo ? replyTo.id : null
      }
      this.replyToUserName = replyTo ? replyTo.userName : comment.userName
      this.replyContent = replyTo ? `@${replyTo.userName} ` : ''
    },
    
    cancelReply() {
      this.currentReplyTarget = {
        parentId: null,
        replyToId: null
      }
      this.replyContent = ''
      this.replyToUserName = ''
    },
    insertEmoji(emoji) {
      this.commentContent += emoji
    },
    insertReplyEmoji(emoji) {
      this.replyContent += emoji
    },
    
    async likeComment(comment) {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}')
      if (!loginResult.userId) {
        this.$message.warning('请先登录')
        return
      }
      
      try {
        const response = await this.$axios({
          method: 'post',
          url: '/comment/like',
          data: {
            commentId: comment.id,
            token: loginResult.token || '',
            userId: loginResult.userId,
            userName: loginResult.userName || '',
            ip: '',
            source: 'web'
          }
        })
        
        if (response.code === 200 || response.code === '200') {
          comment.isLiked = true
          comment.likeCount = (comment.likeCount || 0) + 1
          this.$message.success('点赞成功')
        } else {
          this.$message.error(response.msg || '操作失败')
        }
      } catch (error) {
        console.error('点赞失败:', error)
        this.$message.error('操作失败')
      }
    },
    
    handlePageChange(page) {
      this.currentPage = page
      this.loadComments()
    },
    
    goToUserCenter(userId) {
      const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}')
      if (loginResult.userId && loginResult.userId.toString() === userId.toString()) {
        this.$router.push({ name: 'UserCenter' })
      } else {
        this.$router.push({ name: 'OtherUserCenter', params: { userId: userId } })
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      
      const date = new Date(dateString)
      const now = new Date()
      const diffMs = now - date
      const diffMins = Math.floor(diffMs / 60000)
      const diffHours = Math.floor(diffMs / 3600000)
      const diffDays = Math.floor(diffMs / 86400000)
      
      if (diffMins < 1) return '刚刚'
      if (diffMins < 60) return `${diffMins}分钟前`
      if (diffHours < 24) return `${diffHours}小时前`
      if (diffDays < 30) return `${diffDays}天前`
      
      return date.getFullYear() === now.getFullYear()
        ? `${date.getMonth() + 1}-${date.getDate()}`
        : `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    }
  }
}
</script>

<style scoped>
.local-comment-component {
  margin-top: 24px;
}

.comment-form {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

.comment-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  
  .emoji-picker {
    margin-right: auto;
  }
}

.reply-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  
  .emoji-wrapper {
    flex: 1;
  }
}

.emoji-picker {
  display: inline-block;
}

.comments-list {
  margin-top: 20px;
}

.comment-item {
  display: flex;
  padding: 16px 0;
  border-bottom: 1px solid #eee;
}

.comment-avatar {
  margin-right: 12px;
}

.comment-content {
  flex: 1;
}

.comment-header {
  margin-bottom: 8px;
}

.comment-author {
  font-weight: 600;
  color: #333;
  margin-right: 12px;
}

.comment-time {
  color: #999;
  font-size: 12px;
}

.comment-text {
  margin-bottom: 8px;
  line-height: 1.6;
  color: #444;
}

.comment-footer {
  display: flex;
  gap: 16px;
}

.reply-list {
  margin-top: 12px;
  padding-left: 40px;
  border-left: 2px solid #f0f0f0;
}

.reply-item {
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.reply-item:last-child {
  border-bottom: none;
}

.reply-content {
  margin-bottom: 4px;
  font-size: 13px;
}

.reply-author {
  font-weight: 600;
  color: #333;
}

.reply-to {
  color: #999;
  font-size: 12px;
}

.reply-to-user {
  color: #667eea;
}

.reply-text {
  color: #666;
}

.reply-meta {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 8px;
}

.reply-form {
  margin-top: 12px;
  padding: 12px;
  background: #fafafa;
  border-radius: 4px;
}

.reply-actions {
  text-align: right;
  margin-top: 8px;
}

.no-comments {
  text-align: center;
  color: #999;
  padding: 40px 0;
}

.comment-pagination {
  margin-top: 24px;
  text-align: center;
}

.liked {
  color: #f56c6c;
}
</style>